<div class="form-container">
  <form class="form" [formGroup]="form" (ngSubmit)="submit(); submited = true;">
    <div class="checkbox-container">
      <div class="d-flex justify-content-center">
        <mat-checkbox color="primary"
          [checked]="currentlyChecked === CheckboxOption.ONE_WAY"
          (change)="selectCheckbox(CheckboxOption.ONE_WAY)">
          Somente Ida
        </mat-checkbox>

        <mat-checkbox color="primary"
          [checked]="currentlyChecked === CheckboxOption.ROUND_TRIP"
          (change)="selectCheckbox(CheckboxOption.ROUND_TRIP)">
          Ida e Volta
        </mat-checkbox>
      </div>

      @if (submited && form.controls.option.errors?.required) {
        <app-error-form>
          Marque uma opção.
        </app-error-form>
      }
    </div>

    <div class="d-flex flex-column gap-3">
      <div>
        <input class="input-autocomplete aeroport-origin"
          type="text"
          placeholder="Origem"
          formControlName="airportOrigin"
          [matAutocomplete]="autoAirportOrigin">
          <mat-autocomplete #autoAirportOrigin="matAutocomplete">
            @for (airport of filteredAirportsOrigin | async; track airport) {
              <mat-option [value]="airport.airportInfo.iataCode">
                <div class="autocomplete-selection">
                  <span>{{ airport.city.name  }} - <strong>{{ airport.airportInfo.iataCode }}</strong></span>
                  <span class="airport-name">{{ airport.airportInfo.name }}</span>
                </div>
              </mat-option>
            }
          </mat-autocomplete>

          @if (submited && form.controls.airportOrigin.errors?.required) {
            <app-error-form>
              Informe a Origem.
            </app-error-form>
          }
        </div>

        <div>
          <input class="input-autocomplete aeroport-destiny"
            type="text"
            placeholder="Destino"
            formControlName="airportDestiny"
            [matAutocomplete]="autoAirportDestiny">
            <mat-autocomplete #autoAirportDestiny="matAutocomplete">
              @for (airport of filteredAirportsDestiny | async; track airport) {
                <mat-option [value]="airport.airportInfo.iataCode">
                  <div class="autocomplete-selection">
                    <span>{{ airport.city.name  }} - <strong>{{ airport.airportInfo.iataCode }}</strong></span>
                    <span class="airport-name">{{ airport.airportInfo.name }}</span>
                  </div>
                </mat-option>
              }
            </mat-autocomplete>

            @if (submited && form.controls.airportDestiny.errors?.required) {
              <app-error-form>
                Informe o Destino.
              </app-error-form>
            }

            @if (submited && form.errors?.routeInvalid) {
              <app-error-form>
                A Origem e o Destino não pode ser igual.
              </app-error-form>
            }

            @if (form.hasError('invalidOption')) {
              <app-error-form>
                Rotas internacionais não permitidas
              </app-error-form>
            }

          </div>

          <div>
            <div class="input-date_group">
              <div class="calendar-icon">
                <img src="assets/images/calendar.svg" alt="Calendar">
              </div>

              <div class="input-date_item dt-departure">
                <span class="input-date_label" (click)="pickerDtDeparture.open()">Ida</span>
                <input formControlName="dtDeparture" placeholder="Ida"
                  matInput [matDatepicker]="pickerDtDeparture"
                  (click)="pickerDtDeparture.open()" [min]="minDate" [max]="maxDateOutbound"/>
                  <mat-datepicker #pickerDtDeparture></mat-datepicker>
                </div>

                <span class="input-date_group-line"></span>

                <div class="input-date_item" [class.disable]="currentlyChecked !== CheckboxOption.ROUND_TRIP">
                  <span class="input-date_label" (click)="pickerDtArrival.open()">Volta</span>
                  <input formControlName="dtArrival" placeholder="Volta"
                    matInput [matDatepicker]="pickerDtArrival"
                    (click)="pickerDtArrival.open()" [min]="minDate" [max]="maxDateInbound"/>
                    <mat-datepicker #pickerDtArrival></mat-datepicker>
                  </div>
                </div>

                @if (submited && form.controls.dtDeparture.errors?.required) {
                  <app-error-form>
                    Informe a data de Ida.
                  </app-error-form>
                }

                @if (submited && form.errors?.dtArrivalRequired) {
                  <app-error-form>
                    Informe a data de Volta.
                  </app-error-form>
                }

                @if (submited && form.errors?.periodInvalid) {
                  <app-error-form>
                    A data de Ida não pode ser maior que a data de Volta.
                  </app-error-form>
                }
              </div>

              <div>
                <button class="btn-search" type="submit" [disabled]="form.invalid">Pesquisar</button>
              </div>
            </div>
          </form>
        </div>